import { globalInit } from "./_global";
import { homeInit, sliderInterval } from "./_home";
import { productInit } from "./_product";
import { quizInit } from "./_quiz";
import { contactInit } from "./_contact";
import { newsInit } from "./_news";
import { navInit } from "./_nav";
import { ageVerificationInit } from "./_age";
import { locatorInit } from "./_locator";
import { aboutInit } from "./_about";

$(document).ready(function() {

    init();

    const swup = new Swup({
        animateHistoryBrowsing: true
    });
    swup.on('willReplaceContent', unbind);
    swup.on('contentReplaced', init);
});

function init() {
    // Scroll to top
    var body = $("html, body");
    body.stop().animate({ scrollTop: 0 }, 500, 'swing', function() {});

    // Parallax
    refreshRellax();

    // Scroll Inertia
    // luxy.init();

    globalInit();
    ageVerificationInit();
    navInit();
    quizInit();
    newsInit();

    if (document.querySelector("#locator-map")) {
        locatorInit();
    }

    if (document.querySelector(".page-product")) {
        productInit();
    }

    if (document.querySelector(".page-contact")) {
        contactInit();
    }

    if (document.querySelector(".page-home")) {
        homeInit();
    }

    // About Init (for Remodal)
    if (document.querySelector(".page-about")) {
        aboutInit();
    }
}

function refreshRellax() {
    if ($('.rellax')[0]) {

        // Delay to fix offset issue when navigating between pages
        setTimeout(function() {
            window.rellax = new Rellax('.rellax', {
                speed: 1,
                center: true,
                wrapper: null,
                round: true,
                vertical: true,
            });
        }, 500);
    }
}

function unbind() {
    clearInterval(sliderInterval);

    // luxy.cancel();

    // if ($('.rellax')[0]) {
    //     window.rellax.destroy();
    // }
}